import { SandboxIframe } from '#src/app/pages/startAPetitionV2/shared/components';

import { Loading } from './components/Loading';
import { useChatAgent } from './hooks/useChatAgent';

export const ChatAgent: React.FC = () => {
	const { data, actions } = useChatAgent();

	return (
		<>
			{data.loading && <Loading />}
			{/* eslint-disable-next-line @change-corgi/require-data-qa-attribute */}
			<SandboxIframe src={data.iframeSrc} title="Petition Agent" onSubmit={actions.onSubmit} hidden={data.loading} />
		</>
	);
};
